module.exports = __webpack_public_path__ + "img/times-regular.1e5bee47.svg";